(() => {
  const isBoardRoute = path => /\/collections\/(?:boards?|skim|surf|foil(?:-boards|-packages)?|boards?-sale|boards?-2027|pre-order)(?:\/|$)/.test(path);
  const defaultSort = isBoardRoute(location.pathname) ? 'manual' : 'best-selling';
  if (location.pathname.includes('/collections/') && !new URLSearchParams(location.search).has('sort_by')) {
    const sorted = new URL(location.href); sorted.searchParams.set('sort_by', defaultSort); location.replace(sorted.href); return;
  }
  let showUnavailable = new URLSearchParams(location.search).getAll('filter.v.availability').includes('0');
  let view = 'grid';
  try { view = localStorage.getItem('p5-live-view') || 'grid'; } catch (_) {}
  if (!['grid', 'compact', 'list'].includes(view)) view = 'grid';
  const setText = (node, text) => { if (node && node.textContent !== text) node.textContent = text; };
  function matchesPreorder(meta, tags, params, omitted) {
      const names = [...new Set([...params.keys()].filter(name => name.startsWith('filter.') && name !== omitted))];
      return names.every(name => {
        const values = params.getAll(name);
        if (name === 'filter.v.availability') return true;
        if (name === 'filter.p.m.custom.year') return values.includes('2027');
        if (name === 'filter.p.tag') return values.some(value => tags.includes(value));
        if (name === 'filter.p.vendor') return values.includes(meta.vendor);
        if (name === 'filter.p.product_type') return values.includes(meta.type);
        if (name.startsWith('filter.v.')) return true;
        return false;
      }) && meta.variants.some(variant => names.filter(name => name.startsWith('filter.v.')).every(name => {
        const values = params.getAll(name);
        if (name === 'filter.v.availability') return true;
        if (name === 'filter.v.price.gte') return !values[0] || variant.price >= Number(values[0]);
        if (name === 'filter.v.price.lte') return !values[0] || variant.price <= Number(values[0]);
        if (name.startsWith('filter.v.option.')) return values.includes(variant.options[name.slice(16)]);
        return false;
      }));
  }
  function updateCatalogue(root) {
    const toolbar = root.querySelector('[data-p5-toolbar]');
    if (!toolbar) return;
    const mobileFilter = toolbar.querySelector('[data-p5-mobile-filter]');
    if (mobileFilter) mobileFilter.hidden = !document.getElementById('facets-drawer');
    const cards = [...root.querySelectorAll('product-list > product-card')];
    const params = new URLSearchParams(location.search);
    const stockOnly = params.get('p5_stock') === 'available';
    const category = params.get('p5_category') || (/\/collections\/skim(?:\/|$)/.test(location.pathname) ? 'skim' : /\/collections\/surf(?:\/|$)/.test(location.pathname) ? 'surf' : null);
    const taxonomyNode = root.querySelector('[data-p5-taxonomy]');
    const labelsNode = root.querySelector('[data-p5-taxonomy-labels]');
    if(category && taxonomyNode && labelsNode){
      const reference=JSON.parse(taxonomyNode.textContent),labels=JSON.parse(labelsNode.textContent);
      const known=['pro-models','skim','surf','performance-skim','premium-skim','ltd-skim','hybrid','performance-surf','fun-surf','stealth-surf','skim-fins','surf-fins','board-bags'];
      if(known.includes(category)){
        const heading=document.querySelector('main h1');if(heading)setText(heading,(category === 'pro-models' ? root.querySelector('[data-p5-active-filters]').dataset.proLabel : labels[category])||labels[category==='board-bags'?'bags':category]);
        for(const card of cards){
          const title=card.dataset.p5Title||'',upper=title.toUpperCase(),tags=JSON.parse(card.dataset.p5Tags||'[]').map(t=>t.toUpperCase());
          let family=upper.replace(/^\s*20\d{2}\s+/,'').replace(/^THE\s+/,'').replace(/^PHASE\s*(?:FIVE|5)\s+/,'').replace(/\s+BLEM$/,'').trim();
          family=reference.aliases[family]||family;const row=reference.rows.find(r=>r.family===family);const groups=[];
          const isBoard=tags.includes('BOARDS')&&!tags.includes('GIFT VOUCHER')&&!upper.includes('GIFT');
          if (isBoard && !tags.includes('FOIL') && /\bPRO\b/.test(family)) groups.push('pro-models');
          const hybrid=/^(SWITCHBLADE|FIREBALL)( |$)/.test(family);
          if(isBoard && (hybrid||(row?row.style==='Skim':tags.includes('SKIM')&&!tags.includes('SURF'))) && !tags.includes('FOIL')){
            groups.push('skim');if(upper.includes('LTD'))groups.push('ltd-skim');else if(hybrid)groups.push('hybrid');else groups.push(Number(card.dataset.p5Regular)<100000?'performance-skim':'premium-skim');
          }
          if(isBoard && !hybrid && (row?row.style==='Surf':tags.includes('SURF')) && !tags.includes('FOIL')){
            groups.push('surf');if(row?.category==='Fun Surf Style')groups.push('fun-surf');else if(row?.category==='Stealth Surf Style'||tags.includes('STEALTH SURF'))groups.push('stealth-surf');else if(row?.category==='Performance Surf Style'||tags.includes('PERFORMANCE SURF'))groups.push('performance-surf');
          }
          if((tags.includes('FINS')||upper.includes('FIN'))&&(tags.includes('SKIM')||upper.includes('SKIM')))groups.push('skim-fins');
          if((tags.includes('FINS')||upper.includes('FIN'))&&(tags.includes('SURF')||upper.includes('SURF')))groups.push('surf-fins');
          if(upper.includes('BAG')&&(upper.includes('BOARD')||upper.includes('SURF')||upper.includes('SKIM')))groups.push('board-bags');
          card.toggleAttribute('data-p5-category-hidden',!groups.includes(category));
        }
      }
    }
    const preorderCards = cards.filter(card => card.hasAttribute('data-p5-preorder-card'));
    for (const card of preorderCards) {
      card.toggleAttribute('data-p5-facet-hidden', stockOnly || !matchesPreorder(JSON.parse(card.dataset.p5Facets), JSON.parse(card.dataset.p5Tags), params));
    }
    if (preorderCards.length) {
      const sizes = [...new Set(preorderCards.flatMap(card => JSON.parse(card.dataset.p5Facets).variants.map(variant => variant.options.size)).filter(Boolean))].sort((a, b) => a.localeCompare(b, undefined, {numeric:true}));
      document.querySelectorAll('form[is="facet-form"]').forEach(form => {
        const inputs = [...form.querySelectorAll('input[name="filter.v.option.size"]')];
        if (!inputs.length) return;
        const source = inputs[0];
        for (const size of sizes.filter(size => !inputs.some(input => input.value === size))) {
          const input = source.cloneNode(false); input.id = source.id + '-preorder-' + encodeURIComponent(size); input.value = size;
          input.checked = params.getAll(input.name).includes(size); input.dataset.p5NativeCount = '0';
          const label = source.parentElement.querySelector('label[for="' + source.id + '"]').cloneNode(false); label.htmlFor = input.id; label.textContent = size + ' (0)';
          if (source.parentElement.classList.contains('checkbox-container')) {
            const wrapper = source.parentElement.cloneNode(false); wrapper.append(input, label); source.parentElement.parentElement.append(wrapper);
          } else source.parentElement.append(input, label);
        }
      });
    }
    document.querySelectorAll('input[name="filter.v.option.size"]').forEach(input => {
      if (!preorderCards.length) return;
      const label = input.parentElement.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      if (!input.dataset.p5NativeCount) input.dataset.p5NativeCount = label.textContent.match(/\((\d+)\)\s*$/)?.[1] || '0';
      const extra = preorderCards.filter(card => {
        const meta = JSON.parse(card.dataset.p5Facets);
        return !card.hasAttribute('data-p5-category-hidden') && matchesPreorder(meta, JSON.parse(card.dataset.p5Tags), params, input.name) && meta.variants.some(variant => variant.options.size === input.value);
      }).length;
      const count = (/\/collections\/pre-order(?:\/|$)/.test(location.pathname) ? 0 : Number(input.dataset.p5NativeCount)) + extra;
      input.disabled = !count && !input.checked;
      setText(label, input.value + ' (' + count + ')');
    });
    if (cards.some(card => card.hasAttribute('data-p5-preorder-card'))) {
      document.querySelectorAll('form[is="facet-form"]').forEach(form => {
        const inputs = [...form.querySelectorAll('input[name="filter.p.m.custom.year"]')];
        if (!inputs.length || inputs.some(input => input.value === '2027')) return;
        const source = inputs[inputs.length - 1];
        const input = source.cloneNode(false);
        input.id = source.id + '-preorder-2027'; input.value = '2027'; input.disabled = false;
        input.checked = params.getAll(input.name).includes('2027');
        const label = source.parentElement.querySelector('label[for="' + source.id + '"]').cloneNode(false);
        label.htmlFor = input.id; label.textContent = '2027 (' + preorderCards.length + ')';
        if (source.parentElement.classList.contains('checkbox-container')) {
          const wrapper = source.parentElement.cloneNode(false); wrapper.append(input, label); source.parentElement.parentElement.append(wrapper);
        } else source.parentElement.append(input, label);
      });
    }
    if (/\/collections\/pre-order(?:\/|$)/.test(location.pathname)) {
      document.querySelectorAll('input[name="filter.p.m.custom.year"]').forEach(input => {
        if (input.value === '2027') return;
        const label = input.parentElement.querySelector('label[for="' + input.id + '"]');
        input.disabled = !input.checked;
        if (label) setText(label, input.value + ' (0)');
      });
    }
    const active = root.querySelector('[data-p5-active-filters]');
    if (active) {
      const wanted = [];
      if (params.getAll('filter.p.m.custom.year').includes('2027')) wanted.push(['filter.p.m.custom.year', '2027', active.dataset.yearLabel]);
      if (stockOnly) wanted.push(['p5_stock', 'available', active.dataset.stockLabel]);
      const signature = JSON.stringify(wanted) + location.search;
      if (active.dataset.signature !== signature) {
        active.dataset.signature = signature;
        active.replaceChildren(...wanted.map(([name, value, label]) => {
          const url = new URL(location.href);
          const remaining = url.searchParams.getAll(name).filter(v => v !== value);
          url.searchParams.delete(name); remaining.forEach(v => url.searchParams.append(name, v)); url.searchParams.delete('page');
          const link = document.createElement('a'); link.href = url.pathname + url.search; link.textContent = label + ' ×';
          link.setAttribute('aria-label', active.dataset.removeLabel + ': ' + label); return link;
        }));
      }
      active.hidden = !wanted.length;
    }
    const sort = params.get('sort_by') || defaultSort;
    const reference = taxonomyNode ? JSON.parse(taxonomyNode.textContent) : {rows:[],aliases:{}};
    const ranks = new Map(cards.map(card => {
      const title = card.dataset.p5Title || '';
      const tags = JSON.parse(card.dataset.p5Tags || '[]').map(tag => tag.toUpperCase());
      let family = title.toUpperCase().replace(/^\s*20\d{2}\s+/, '').replace(/^THE\s+/, '').replace(/^PHASE\s*(?:FIVE|5)\s+/, '').replace(/\s+BLEM$/, '').trim();
      family = reference.aliases[family] || family;
      const row = reference.rows.find(item => item.family === family);
      const style = tags.includes('FOIL') ? 2 : row?.style === 'Surf' ? 1 : ['Skim','Hybrid'].includes(row?.style) ? 0 : tags.includes('SKIM') ? 0 : tags.includes('SURF') ? 1 : 3;
      const tier = style === 0 ? (row?.construction === 'Carbon' || /Premium|Limited/.test(row?.category || '') || (!row && Number(card.dataset.p5Regular) >= 100000) ? 0 : row?.style === 'Hybrid' ? 1 : 2) : style === 1 ? (/STEALTH/.test(family) ? 0 : row?.category === 'Fun Surf Style' ? 2 : 1) : 0;
      return [card, [card.dataset.p5Available === 'true' || card.hasAttribute('data-p5-preorder-card') ? 0 : 1, -Number(title.match(/\b20\d{2}\b/)?.[0] || 0), style, tier, Number(row?.rank || 99)]];
    }));
    const list = root.querySelector('product-list');
    cards.forEach((card, index) => { if (!card.dataset.p5Order) card.dataset.p5Order = String(index + 1); });
    const ordered = [...cards].sort((a, b) => {
      if (sort.startsWith('price-')) return (Number(a.dataset.p5Price) - Number(b.dataset.p5Price)) * (sort.endsWith('descending') ? -1 : 1);
      if (sort.startsWith('title-')) return a.dataset.p5Title.localeCompare(b.dataset.p5Title) * (sort.endsWith('descending') ? -1 : 1);
      if (sort.startsWith('created-')) return (Date.parse(a.dataset.p5Created) - Date.parse(b.dataset.p5Created)) * (sort.endsWith('descending') ? -1 : 1);
      if (isBoardRoute(location.pathname) && sort === 'manual') {
        const left = ranks.get(a), right = ranks.get(b);
        for (let i = 0; i < left.length; i++) if (left[i] !== right[i]) return left[i] - right[i];
        return a.dataset.p5Title.localeCompare(b.dataset.p5Title) || Number(a.dataset.p5Order) - Number(b.dataset.p5Order);
      }
      const rank = card => card.dataset.p5Available === 'true' ? 0 : card.hasAttribute('data-p5-preorder-card') ? 1 : 2;
      return rank(a) - rank(b) || Number(a.dataset.p5Order) - Number(b.dataset.p5Order);
    });
    if (list && (isBoardRoute(location.pathname) || cards.some(card => card.hasAttribute('data-p5-preorder-card'))) && ordered.some((card, index) => card !== cards[index])) ordered.forEach(card => list.append(card));
    root.dataset.showUnavailable = String(showUnavailable && !stockOnly);
    root.dataset.layout = view;
    toolbar.querySelector('[data-p5-show-unavailable]').checked = showUnavailable && !stockOnly;
    toolbar.querySelector('[data-p5-show-unavailable]').disabled = stockOnly;
    toolbar.querySelectorAll('[data-p5-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.p5View === view)));
    const shown = cards.filter(card => !card.hasAttribute('data-p5-category-hidden') && !card.hasAttribute('data-p5-facet-hidden') && ((showUnavailable && !stockOnly) || card.dataset.p5Available === 'true' || card.hasAttribute('data-p5-preorder-card'))).length;
    setText(toolbar.querySelector('[data-p5-count]'), toolbar.dataset.countTemplate.replace('{shown}', shown).replace('{total}', cards.length));
    const empty = root.querySelector('[data-p5-empty]');
    empty.hidden = shown > 0 || cards.length === 0;
    const reveal = empty.querySelector('[data-p5-reveal-unavailable]');
    if (reveal) reveal.hidden = stockOnly || showUnavailable || !cards.some(card => !card.hasAttribute('data-p5-category-hidden') && !card.hasAttribute('data-p5-facet-hidden') && card.dataset.p5Available !== 'true');
  }
  function preserveFacetContext() {
    const params = new URLSearchParams(location.search);
    document.querySelectorAll('form[is="facet-form"]').forEach(form => {
      for (const name of ['p5_category', 'p5_stock', 'sort_by']) {
        const value = params.get(name) || (name === 'sort_by' ? defaultSort : '');
        let input = form.querySelector('input[data-p5-context="' + name + '"]');
        if (!value) { if (input) input.remove(); continue; }
        if (!input && form.querySelector('[name="' + name + '"]')) continue;
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.dataset.p5Context = name; form.append(input); }
        input.value = value;
      }
    });
    document.querySelectorAll('a[is="facet-link"]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.pathname !== location.pathname) return;
      for (const name of ['p5_category', 'p5_stock', 'sort_by']) {
        const value = params.get(name);
        if (value && !url.searchParams.has(name)) url.searchParams.set(name, value);
      }
      link.href = url.pathname + url.search + url.hash;
    });
  }
  function init() {
    preserveFacetContext();
    document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    document.querySelectorAll('.shopify-section--related-products,.shopify-section--product-recommendations').forEach(section => {
      const recommendations = section.querySelector('product-recommendations');
      if (!recommendations || recommendations.children.length) section.hidden = !section.querySelector('product-card');
    });
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[data-p5-reveal-unavailable]')) {
      showUnavailable = true;
      document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
      event.target.closest('[data-p5-catalogue]')?.querySelector('[data-p5-show-unavailable]')?.focus();
    }
    document.querySelectorAll('[data-p5-category-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-p5-category-menu][open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  function enquiry(link, variant) {
    if (!link) return;
    link.hidden = Boolean(variant?.available);
    const subject = 'Availability: ' + link.dataset.productTitle;
    const page = link.dataset.productUrl + (variant?.id ? '?variant=' + variant.id : '');
    const body = ['Product: ' + link.dataset.productTitle, variant?.title && variant.title !== 'Default Title' ? 'Option: ' + variant.title : '', 'Page: ' + page, 'Delivery country:'].filter(Boolean).join('\n');
    link.href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject, body});
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-p5-show-unavailable]')) {
      showUnavailable = event.target.checked;
      document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    }

  });
  document.addEventListener('variant:change', event => {
    enquiry(event.target.querySelector('[data-p5-enquiry]'), event.detail.variant);
  });
  const contact = document.getElementById('p5-live-contact');
  const newsletter = document.getElementById('p5-live-newsletter');
  const wishlist = document.getElementById('p5-live-wishlist');
  const openers = new WeakMap();
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener);
    dialog.showModal();
  }
  let contactSubject = 'Store enquiry';
  function syncContactEmail() {
    if (!contact) return;
    const body = [contact.querySelector('[name="contact[body]"]')?.value || '', 'Email: ' + (contact.querySelector('[name="contact[email]"]')?.value || '')].join('\n');
    contact.querySelector('[data-p5-direct-email]').href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject:contactSubject, body});
  }
  function openContextEnquiry(subject, body, opener) {
    if (!contact) return;
    contactSubject = subject || 'Store enquiry';
    contact.querySelector('[name="contact[body]"]').value = body || '';
    syncContactEmail(); openDialog(contact, opener);
  }
  contact?.addEventListener('input', syncContactEmail);
  contact?.querySelector('[data-p5-email-only]')?.addEventListener('submit', event => {
    event.preventDefault(); syncContactEmail(); location.href = contact.querySelector('[data-p5-direct-email]').href;
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !contact) return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && url.pathname.endsWith('/pages/contact') && url.searchParams.has('message')) {
      event.preventDefault(); openContextEnquiry(url.searchParams.get('subject'), url.searchParams.get('message'), link);
    }
  });
  const preorder = document.getElementById('p5-preorder-contact');
  const preorderForm = document.getElementById('p5-preorder-contact-form');
  let preorderContext;
  function populatePreorder(context) {
    if (!preorder || !context?.options?.length) return;
    preorderContext = context;
    preorder.querySelector('#p5-preorder-model').value = context.title;
    const select = preorder.querySelector('#p5-preorder-size');
    select.replaceChildren(...context.options.map(option => {
      const node = document.createElement('option');
      node.value = option.title;
      node.textContent = option.title;
      node.dataset.variantId = String(option.id);
      node.selected = String(option.id) === String(context.selected);
      return node;
    }));
    syncPreorderEmail();
  }
  function syncPreorderEmail() {
    if (!preorderContext) return;
    const select = preorder.querySelector('#p5-preorder-size');
    const chosen = select.selectedOptions[0];
    const url = new URL(preorderContext.url, location.origin);
    url.searchParams.set('variant', chosen?.dataset.variantId || preorderContext.selected);
    preorder.querySelector('[data-p5-preorder-url]').value = url.href;
    const body = ['Board: ' + preorderContext.title, 'Size: ' + select.value, 'Page: ' + url.href, 'Name: ' + preorder.querySelector('#p5-preorder-name').value, 'Email: ' + preorder.querySelector('#p5-preorder-email').value, preorder.querySelector('#p5-preorder-message').value].join('\n');
    preorder.querySelector('[data-p5-preorder-email]').href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject:'2027 pre-order request: ' + preorderContext.title, body});
  }
  preorderForm?.addEventListener('input', syncPreorderEmail);
  preorderForm?.addEventListener('change', syncPreorderEmail);
  preorderForm?.addEventListener('submit', () => {
    if (!preorderContext) return;
    const chosen = preorder.querySelector('#p5-preorder-size').selectedOptions[0];
    try { sessionStorage.setItem('p5-preorder-pending', JSON.stringify({...preorderContext, selected:chosen?.dataset.variantId, time:Date.now()})); } catch (_) {}
  });
  let pending;
  try { pending=JSON.parse(sessionStorage.getItem('p5-preorder-pending') || 'null'); } catch (_) {}
  if (pending && Date.now()-pending.time < 1800000 && (preorder?.querySelector('[data-p5-preorder-success], [data-p5-preorder-errors]') || new URLSearchParams(location.search).has('p5_preorder_return'))) {
    populatePreorder(pending);
    const success = preorder.querySelector('[data-p5-preorder-success]');
    if (success) {
      preorder.querySelector('[data-p5-preorder-fields]').hidden = true;
      preorder.querySelector('[data-p5-preorder-email]').hidden = true;
      try { sessionStorage.removeItem('p5-preorder-pending'); } catch (_) {}
    }
    openDialog(preorder, null);
  }

  [contact, newsletter, wishlist, preorder].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => openers.get(dialog)?.focus());
  });
  document.addEventListener('click', event => {
    const preorderTrigger = event.target.closest('[data-p5-preorder-enquiry]');
    if (preorderTrigger && preorder) {
      const panel = preorderTrigger.closest('[data-p5-preorder]');
      let options;
      try { options = JSON.parse(panel.querySelector('[data-p5-preorder-options]').textContent); } catch (_) { return; }
      event.preventDefault();
      populatePreorder({title:panel.dataset.title, url:panel.dataset.productUrl, selected:preorderTrigger.dataset.p5VariantId || panel.dataset.selectedVariant, options});
      preorder.querySelector('[data-p5-preorder-fields]').hidden = false;
      preorder.querySelector('[data-p5-preorder-email]').hidden = false;
      preorder.querySelector('[data-p5-preorder-success]')?.remove();
      openDialog(preorder, preorderTrigger);
      return;
    }
    const contactTrigger = event.target.closest('[data-p5-open-contact]');
    if (contactTrigger) openDialog(contact, contactTrigger);
    const newsletterTrigger = event.target.closest('[data-p5-open-newsletter]');
    if (newsletterTrigger) openDialog(newsletter, newsletterTrigger);
    const viewButton = event.target.closest('[data-p5-view]');
    if (viewButton) {
      view = viewButton.dataset.p5View;
      try { localStorage.setItem('p5-live-view', view); } catch (_) {}
      document.querySelectorAll('[data-p5-catalogue]').forEach(updateCatalogue);
    }
    const link = event.target.closest('a[href]');
    if (contact && link && !link.hasAttribute('data-p5-direct-email') && /^mailto:(info@phase5boards\.eu|phase5europe@gmail\.com|phase5middleeast@gmail\.com)(\?|$)/i.test(link.getAttribute('href'))) {
      event.preventDefault();
      wishlist?.close();
      const params = new URLSearchParams(link.getAttribute('href').split('?')[1] || '');
      contactSubject = params.get('subject') || 'Store enquiry';
      const draft = {subject:params.get('subject') || 'Store enquiry',body:params.get('body') || 'Page: ' + location.origin + location.pathname,time:Date.now()};
      try { sessionStorage.setItem('p5-live-contact-draft', JSON.stringify(draft)); } catch (_) {}
      contact.querySelector('[data-p5-direct-email]').href = 'mailto:info@phase5boards.eu?' + new URLSearchParams({subject:draft.subject,body:draft.body});
      const message = contact.querySelector('[name="contact[body]"]');
      if (message) message.value = [draft.subject,draft.body].filter(Boolean).join('\n\n');
      openDialog(contact, link);
    }
    const wish = event.target.closest('a[href="#swym-wishlist"],button.swym-add-to-wishlist-view-product');
    if (wish) {
      setTimeout(() => {
        const visible = [...document.querySelectorAll('.swym-ui-component,.swym-modal,.swym-notification-wishlist')].some(node => node.getBoundingClientRect().height > 20 && getComputedStyle(node).visibility !== 'hidden' && getComputedStyle(node).display !== 'none');
        if (!visible && !wish.classList.contains('swym-added')) openDialog(wishlist, wish);
      }, 1800);
    }
  });
  if (location.pathname.endsWith('/pages/contact')) {
    let draft;
    const params = new URLSearchParams(location.search);
    if (params.has('message')) draft = {subject:params.get('subject'),body:params.get('message')};
    else try {
      const saved = JSON.parse(sessionStorage.getItem('p5-live-contact-draft') || 'null');
      if (saved && Date.now() - saved.time < 1800000) draft = saved;
    } catch (_) {}
    const message = document.querySelector('[name="contact[body]"]');
    if (draft && message && !message.value) {
      openContextEnquiry(draft.subject, draft.body, null);
      message.value = [draft.subject,draft.body].filter(Boolean).join('\n\n');
      message.dispatchEvent(new Event('input',{bubbles:true}));
      try { sessionStorage.removeItem('p5-live-contact-draft'); } catch (_) {}
    }
  }
  function normaliseLinks() {
    document.querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      let updated = href.trim().replace(/phase5europe@gmail\.com|phase5middleeast@gmail\.com/gi,'info@phase5boards.eu');
      if (/^info@phase5boards\.eu$/i.test(updated)) updated = 'mailto:info@phase5boards.eu';
      if(updated==='/collections/skim')updated='/collections/boards?p5_category=skim';
      if(updated==='/collections/surf')updated='/collections/boards?p5_category=surf';
      if(['/search?view=board-finder','/search?view=p5-board-guide','/pages/board-guide'].includes(updated))updated=document.body.dataset.p5GuideUrl||'/search?view=p5-board-guide';
      const destination = new URL(updated, location.origin);
      if (destination.origin === location.origin && isBoardRoute(destination.pathname) && link.getAttribute('is') !== 'facet-link' && !link.closest('facet-sort-by,.pagination,.collection__pagination') && !destination.searchParams.has('page')) {
        destination.searchParams.set('sort_by', 'manual');
        updated = destination.pathname + destination.search + destination.hash;
      }
      if (updated !== href) {
        link.setAttribute('href', updated);
        if (/^phase5(europe|middleeast)@gmail\.com$/i.test(link.textContent.trim())) {
          const leading = /^\s/.test(link.textContent) ? ' ' : '';
          const trailing = /\s$/.test(link.textContent) ? ' ' : '';
          link.textContent = leading + 'info@phase5boards.eu' + trailing;
        }
      }
    });
  }
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; init(); normaliseLinks(); });
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load', init);
  init();
  normaliseLinks();
})();




document.addEventListener('variant:change',event=>{
  const variant=event.detail?.variant;if(!variant)return;
  event.target.querySelectorAll('[data-p5-preorder]').forEach(panel=>{
    panel.dataset.selectedVariant=String(variant.id);
    const link=panel.querySelector('[data-p5-preorder-enquiry]');if(!link)return;
    link.href='mailto:info@phase5boards.eu?'+new URLSearchParams({subject:'Pre-order enquiry: '+panel.dataset.title,body:['Board: '+panel.dataset.title,'Size: '+variant.title,'Delivery country:'].join('\n')});
  });
});



if(!customElements.get('p5-preview-variants'))customElements.define('p5-preview-variants',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelector('select').addEventListener('change',event=>{const url=new URL(location.href);url.searchParams.set('variant',event.target.value);location.assign(url.href);});}});







